module.exports = __webpack_public_path__ + "img/es-back.ff7f8073.png";